import { Controller } from "@hotwired/stimulus";

// Typesets math after a Turbo Drive visit on layouts that load MathJax once in
// <head> (partials/_mathjax_head). Put it on <body>; the optional `content`
// target narrows what gets typeset.
//
// Skips the first connect after a full page load: MathJax's own startup
// typesets that document, and typesetting it again nests every formula in a
// second mjx-container. This module outlives Drive visits (only <body> is
// swapped), so the flag below is "has this window done a full load yet".
let fullLoadHandled = false;

export default class extends Controller {
  static targets = ["content"];

  connect() {
    if (!fullLoadHandled) {
      fullLoadHandled = true;
      return;
    }

    const mathJax = window.MathJax;
    if (!mathJax?.startup?.promise || !mathJax.typesetPromise) return;

    const elements = this.hasContentTarget ? [this.contentTarget] : [this.element];
    mathJax.startup.promise
      .then(() => {
        mathJax.typesetClear?.();
        return mathJax.typesetPromise(elements);
      })
      .catch((error) => console.warn("MathJax typeset failed", error));
  }
}
